import { createSelector } from 'reselect';
import { calculateTotal } from '../utils/lineItemUtils';

const getContractorLineItemsSelector = state => state.phase.contractorLineItems.items;

const getPhaseLineItemsWithTotal =
  createSelector(
    getContractorLineItemsSelector,
    laborSheets =>
      laborSheets.map((sheet) => {
        const newSheet = sheet;
        newSheet.line_items = newSheet.line_items.map((item) => {
          const itemWithTotal = item;
          itemWithTotal.total = calculateTotal(item.price, item.quantity);
          return itemWithTotal;
        });
        return newSheet;
      }),
  );

export default getPhaseLineItemsWithTotal;



// WEBPACK FOOTER //
// ./client/app/selectors/contractorLineItem.js